import React, { useEffect, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { Result, IcdPayerRules } from "../../interface/IcdPayerRules";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "shared/DataTable";
import { Button } from "../../components/ui/button";
import { IcdPayerRulesAxiosInstance } from "../../Network/IcdPayerRulesAxiosInstance";
import Joi from "joi";
import { Option } from "../../interface/Option";
import NetworkNames from "../Shared/NetworkNames";
import PolicyNames from "../Shared/PolicyNames"

const Relationicdpayer: React.FC = () => {
  const [items, setItems] = useState<IcdPayerRules>({ result: [] });
  const [relation_id, setRelation_id] = useState<number[]>([]);
  const [IdrelationError, setIdRelationError] = useState<string>("");
  const [provider_ids, setProvider_ids] = useState<string[]>([]);
  const [IdproviderError, setIdProviderError] = useState<string>("");
  const [apply_to_other_providers, setApply_to_other_providers] =
    useState<boolean>(false);
  const [networks, setNetworks] = useState<string[]>([]);
  const [apply_to_other_networks, setApply_to_other_networks] =
    useState<boolean>(false);
  const [policies, setPolicies] = useState<string[]>([]);
  const [apply_to_other_policies, setApply_to_other_policies] =
    useState<boolean>(false);
  const [patients, setPatients] = useState<string[]>([]);
  const [apply_to_other_patients, setApply_to_other_patients] =
    useState<boolean>(false);
  const [active, setActive] = useState<boolean>(false);
  const [not_active_to, setNot_active_to] = useState<string[]>([]);
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [searchInput, setSearchInput] = useState<string>("");
  const [filteredItems, setFilteredItems] = useState<any[]>([]);
  const token = localStorage.getItem('token') || "";
  const [selectedNetworks, setSelectedNetworks] = useState<Option[]>([]);
  const [selectedPolicy, setSelectedPolicy] = useState<Option[]>([]);  

  const idrelationschema = Joi.string().allow("") // Allow empty string
  .regex(/^[0-9,]*$/)
  .messages({
    "string.pattern.base": "Please enter only numbers",
  });  
  const idproviderschema = Joi.string().allow("") // Allow empty string
  .regex(/^[0-9,]*$/)
  .messages({
    "string.pattern.base": "Please enter only numbers",
  });
  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await IcdPayerRulesAxiosInstance.get("geticdpayer");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const handlIdrelationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
  // check the entry using Joi
    const { error } = idrelationschema.validate(value);
  
    if (error) {
      setIdRelationError(error.message); 
    } else {
      setIdRelationError(""); 
      const inputValue = e.target.value.trim();
      setRelation_id(e.target.value.split(",").map(Number))
     }
  };

  const handlIdproviderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
  // check the entry using Joi
    const { error } = idproviderschema.validate(value);
  
    if (error) {
      setIdProviderError(error.message); 
    } else {
      setIdProviderError(""); 
      const inputValue = e.target.value.trim();
      setProvider_ids([e.target.value])
     }
  };
  const addItem = async (): Promise<void> => {
    const Networks=selectedNetworks.map(option => option.label);
    const Policy=selectedPolicy.map(option => option.label);
    try {
      const newIcdPayerRules = {
        relation_id: relation_id,
        provider_ids: provider_ids,
        apply_to_other_providers: apply_to_other_providers,
        networks: Networks,
        apply_to_other_networks: apply_to_other_networks,
        policies: Policy,
        apply_to_other_policies: apply_to_other_policies,
        patients: patients,
        apply_to_other_patients: apply_to_other_patients,
        active: active,
        not_active_to:not_active_to,
        token: token,
      };
      await IcdPayerRulesAxiosInstance.post(
        "addicdpayer",
        newIcdPayerRules
      );
      fetchItems();
      setRelation_id([]);
      setProvider_ids([]);
      setApply_to_other_providers(false);
      setApply_to_other_networks(false);
      setApply_to_other_policies(false);
      setPatients([]);
      setApply_to_other_patients(false);
      setActive(false);
      setNot_active_to([]);
  
      setSelectedNetworks([]);
      setSelectedPolicy([]);
  
      console.log("New group Added Successfully:", newIcdPayerRules);

      console.log(items);
    } catch (error) {
      console.error("Error adding item:", error);
    }
  };

  const updateItem = async (id: string | number): Promise<void> => {
    const Networks=selectedNetworks.map(option => option.label);
    const Policy=selectedPolicy.map(option => option.label);
    try {
      const updatedItem = {

        relation_id: relation_id,
        provider_ids: provider_ids,
        apply_to_other_providers: apply_to_other_providers,
        networks: Networks,
        apply_to_other_networks: apply_to_other_networks,
        policies: Policy,
        apply_to_other_policies: apply_to_other_policies,
        patients: patients,
        apply_to_other_patients: apply_to_other_patients,
        active: active,
        not_active_to:not_active_to,
        id: id,
        token: token,

      }
      await IcdPayerRulesAxiosInstance.put(
        `updateicdpayer`,
        updatedItem
      );
      fetchItems();
      setRelation_id([]);
      setProvider_ids([]);
      setApply_to_other_providers(false);
      setApply_to_other_networks(false);
      setApply_to_other_policies(false);
      setPatients([]);
      setApply_to_other_patients(false);
      setActive(false);
      setNot_active_to([]);
  
      setSelectedNetworks([]);
      setSelectedPolicy([]);
      setEditIndex(null);
      console.log("New group Added Successfully:", updateItem);

    }
      catch (error) {
        console.error("Error update item:", error);
      }

    }


  const deletePayerRule = async (id: string | number): Promise<void> => {
    try {
      const response: AxiosResponse = await IcdPayerRulesAxiosInstance.delete(
        `deleteicdpayer/${id}`, {
      
           data: { token: token }, 
         }
      );
      if (response.data.success) {
        console.log("Payer rule Deleted Successfully:", response.data);
        fetchItems();
      } else {
        console.error("Error deleting payer rule:", response.data.error);
      }
    } catch (error) {
      console.error("Error deleting payer rule:", error);
    }
  };



  const resetForm = () => {
    setRelation_id([]);
    setProvider_ids([]);
    setApply_to_other_providers(false);
    setNetworks([]);
    setApply_to_other_networks(false);
    setPolicies([]);
    setApply_to_other_policies(false);
    setPatients([]);
    setApply_to_other_patients(false);
    setActive(false);
    setNot_active_to([]);
    setEditIndex(null);
  };
  {
    /*
  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      performSearch();
    }
  };

  const performSearch = () => {
    if (searchInput.trim() === '') {
      setFilteredItems(items);
    } else {
      const searchResult = items.filter(item => 
        item.relation_id.toString().includes(searchInput) ||
        (item.provider_ids ? item.provider_ids.join(', ').toLowerCase().includes(searchInput.toLowerCase()) : false) ||
        (item.networks ? item.networks.join(', ').toLowerCase().includes(searchInput.toLowerCase()) : false) ||
        (item.policies ? item.policies.join(', ').toLowerCase().includes(searchInput.toLowerCase()) : false) ||
        (item.patients ? item.patients.join(', ').toLowerCase().includes(searchInput.toLowerCase()) : false) ||
        (item.not_active_to ? item.not_active_to.join(', ').toLowerCase().includes(searchInput.toLowerCase()) : false) ||
        item.active.toString().includes(searchInput.toLowerCase())
      );
      setFilteredItems(searchResult);
}
  };*/
  }

  const handleNetworksChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedNetworks(selectedOptions);
  };
  const handlePolicyChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedPolicy(selectedOptions);
  };
  const handleEdit =  (item: Result) => {
    setRelation_id(item.relation_id);
    setProvider_ids(item.provider_ids);
    setApply_to_other_providers(item.apply_to_other_providers);
   const Networks = (item.networks || []).map((networks: string) => ({
    label: networks,
    value: networks,
  }));
  setSelectedNetworks(Networks);
 const Policy = (item.policies || []).map((policies: string) => ({
    label: policies,
    value: policies,
  }));
  setSelectedPolicy(Policy);
   
    setApply_to_other_networks(item.apply_to_other_networks);
    setApply_to_other_policies(item.apply_to_other_policies);
    setPatients(item.patients);
    setApply_to_other_patients(item.apply_to_other_patients);
    setActive(item.active);
    setNot_active_to(item.not_active_to);
    setEditIndex(item.id);
  }
  
  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "relation_id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
RelationID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const codes = row.getValue("relation_id") as string[];
        return Array.isArray(codes) ? codes.join(", ") : codes;
      },
    },
    {
      accessorKey: "provider_ids",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
ProviderIDs
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const codes = row.getValue("provider_ids") as string[];
        return Array.isArray(codes) ? codes.join(", ") : codes;
      },
    },
    {
      accessorKey: "apply_to_other_providers",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        ApplyToOtherProviders
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
    {
      accessorKey: "networks",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Networks
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Networks = row.getValue("networks") as string[];
        return Array.isArray(Networks) ? Networks.join(", ") : Networks;
      },
    },
    {
      accessorKey: "policies",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Policies
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Policies = row.getValue("policies") as string[];
        return Array.isArray(Policies) ? Policies.join(", ") : Policies;
      },
    },
    {
      accessorKey: "patients",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Patients
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Patients = row.getValue("patients") as string[];
        return Array.isArray(Patients) ? Patients.join(", ") : Patients;
      },
    },
    {
      accessorKey: "active",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 Active
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
  
    {
      accessorKey: "apply_to_other_networks",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 ApplyToOtherNetworks
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
      {
      accessorKey: "apply_to_other_policies",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        ApplyToOtherPolicies
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
    {
      accessorKey: "apply_to_other_patients",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        ApplyToOtherPatients
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
    {
      accessorKey: "not_active_to",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Not Active To
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Not = row.getValue("not_active_to") as string[];
        return Array.isArray(Not) ? Not.join(", ") : Not;
      },
    },
  ];
  // const columns: Column<any>[] = [
  //   { header: "Relation ID", accessor: "relation_id",Cell: ({ value }) => (Array.isArray(value) ? value.join(", ") : value) },
  //   {
  //     header: "Provider ID",
  //     accessor: "provider_ids",
  //     Cell: ({ value }) => (Array.isArray(value) ? value.join(", ") : value),
  //   },
  //   {
  //     header: "apply to other providers",
  //     accessor: "apply_to_other_providers",
  //     Cell: ({ value }) => (value ? "true" : "false"),
  //   },
  //   {
  //     header: "Networks",
  //     accessor: "networks",
  //     Cell: ({ value }) => (Array.isArray(value) ? value.join(", ") : value),
  //   },
  //   {
  //     header: "apply to other networks",
  //     accessor: "apply_to_other_networks",
  //     Cell: ({ value }) => (value ? "true" : "false"),
  //   },
  //   {
  //     header: "Policies",
  //     accessor: "policies",
  //     Cell: ({ value }) => (Array.isArray(value) ? value.join(", ") : value),
  //   },
  //   {
  //     header: "apply to other policies",
  //     accessor: "apply_to_other_policies",
  //     Cell: ({ value }) => (value ? "true" : "false"),
  //   },
  //   {
  //     header: "Patients",
  //     accessor: "patients",
  //     Cell: ({ value }) => (Array.isArray(value) ? value.join(", ") : value),
  //   },
  //   {
  //     header: "apply to other patients",
  //     accessor: "apply_to_other_patients",
  //     Cell: ({ value }) => (value ? "true" : "false"),
  //   },
  //   {
  //     header: "Not Active To",
  //     accessor: "not_active_to",
  //     Cell: ({ value }) => (Array.isArray(value) ? value.join(", ") : value),
  //   },
  //   {
  //     header: "Active",
  //     accessor: "active",
  //     Cell: ({ value }) => (value ? "true" : "false"),
  //   },
  // ];
  return (
    <div className=" container" style={{ margin: "30px" }}>
      {/* title */}
      <h5>
        ICD Payer Rules Screen{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>
     
      {/* model */}
      {/* tabIndex="-1" */}
      <div
  className="modal fade"
  id="exampleModal"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog">
    <div className="modal-content" style={{ width: "135%" }}>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          Add Item
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div className="container">
        <div className="row">
          {/* First Column */}
          <div className="col-md-6">
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2">Relation ID:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={relation_id.join(",")}
                onChange={handlIdrelationChange}
              />
               {IdrelationError && <div style={{ color: "red" }}>{IdrelationError}</div>}
            </div>
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2">Provider ID:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={provider_ids.join(",")}
                onChange={handlIdproviderChange}
              />
                {IdproviderError && <div style={{ color: "red" }}>{IdproviderError}</div>}
            </div>
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2">Networks:</label>
           {/*   <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={networks.join(",")}
                onChange={(e) => setnetworks([e.target.value])}
              />*/}
            <div style={{ width: "130%"}}>
            <NetworkNames onChange={handleNetworksChange} />
            </div> 
            </div>
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2">Policies:</label>
            {/*  <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={policies.join(",")}
                onChange={(e) => setpolicies([e.target.value])}
              />*/}
               <div style={{ width: "130%"}}>
               <PolicyNames onChange={handlePolicyChange} />
            </div> 
            </div>
            <div style={{ marginBottom: "30px" }}>
              <label className="m-2"> Patients:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={patients.join(",")}
                onChange={(e) => setPatients([e.target.value])}
              />
            </div>
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2">Not Activity To:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={not_active_to.join(",")}
                onChange={(e) => setNot_active_to([e.target.value])}
              />
            </div>
          </div>


          {/* Second Column */}
          <div className="col-md-6">
         
            <div style={{ marginBottom: "50px",marginTop:"122px" }}>
            <span>
              <label className="m-2"> Apply To Other Providers:</label>
              <span style={{ marginRight: "10px" }}>
                {" "}
                True:{" "}
                <input
                  type="radio"
                  name="Providers"
                  value="true"
                  checked={apply_to_other_providers === true}
                  onChange={(e) =>
                    setApply_to_other_providers(e.target.value === "true")
                  }
                />{" "}
              </span>
              <span>
                {" "}
                False:{" "}
                <input
                  type="radio"
                  name="Providers"
                  value="false"
                  checked={apply_to_other_providers === false}
                  onChange={(e) =>
                    setApply_to_other_providers(e.target.value === "true")
                  }
                />{" "}
              </span>
            </span>
</div>
<div style={{ marginBottom: "45px" }}>
            <span>
              <label className="m-2"> Apply To Other Networks:</label>
              <span style={{ marginRight: "10px" }}>
                {" "}
                True:{" "}
                <input
                  type="radio"
                  name="Networks"
                  value="true"
                  checked={apply_to_other_networks === true}
                  onChange={(e) =>
                    setApply_to_other_networks(e.target.value === "true")
                  }
                />{" "}
              </span>
              <span>
                {" "}
                False:{" "}
                <input
                  type="radio"
                  name="Networks"
                  value="false"
                  checked={apply_to_other_networks === false}
                  onChange={(e) =>
                    setApply_to_other_networks(e.target.value === "true")
                  }
                />{" "}
              </span>
            </span>
     </div>
     <div style={{ marginBottom: "50px" }}>
            <span>
              
              <label className="m-2"> Apply To Other Policies:</label>
              <span style={{ marginRight: "10px" }}>
                {" "}
                True:{" "}
                <input
                  type="radio"
                  name="Policies"
                  value="true"
                  checked={apply_to_other_policies === true}
                  onChange={(e) =>
                    setApply_to_other_policies(e.target.value === "true")
                  }
                />{" "}
              </span>
              <span>
                {" "}
                False:{" "}
                <input
                  type="radio"
                  name="Policies"
                  value="false"
                  checked={apply_to_other_policies === false}
                  onChange={(e) =>
                    setApply_to_other_policies(e.target.value === "true")
                  }
                />{" "}
              </span>
            </span>
            </div>
            <div style={{ marginBottom: "70px" }}>
            <span>
                  <label className="m-2"> Apply To Other Patients :</label>

                  <span style={{ marginRight: "10px" }}>
                    {" "}
                    True:{" "}
                    <input
                      type="radio"
                      name="Patients"
                      value="true"
                      checked={apply_to_other_patients === true}
                      onChange={(e) =>
                        setApply_to_other_patients(e.target.value === "true")
                      }
                    />{" "}
                  </span>
                  <span>
                    {" "}
                    False:{" "}
                    <input
                      type="radio"
                      name="Patients"
                      value="false"
                      checked={apply_to_other_patients === false}
                      onChange={(e) =>
                        setApply_to_other_patients(e.target.value === "true")
                      }
                    />{" "}
                  </span>
                </span>
          
             </div>
          <span>
                  <label className="m-2"> Active :</label>

                  <span style={{ marginRight: "10px" }}>
                    {" "}
                    True:{" "}
                    <input
                      type="radio"
                      name="active"
                      value="true"
                      checked={active === true}
                      onChange={(e) => setActive(e.target.value === "true")}
                    />{" "}
                  </span>
                  <span>
                    {" "}
                    False:{" "}
                    <input
                      type="radio"
                      name="active"
                      value="false"
                      checked={active === false}
                      onChange={(e) => setActive(e.target.value === "true")}
                    />{" "}
                  </span>
                </span>
                </div>
        </div>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary"
          onClick={editIndex === null ? addItem : () => updateItem(editIndex)}
        >
          {editIndex === null ? "Add Item" : "Update Item"}
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={resetForm}
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>


      {/* table */}
      <DataTable
  columns={columns}
  data={items.result}
  searchColumn="relation_id"
  addButtonLabel="Add New ICD Payer Rules" // Custom button text
  modalId="exampleModal" // Custom add modal ID
  showAddButton={true} // Control visibility
  onEdit={handleEdit}
  onDelete={deletePayerRule}
/>
    </div>
  );
};

export default Relationicdpayer;
